import React from 'react';
import PropTypes from 'prop-types';
import roundReportStorageItemAdminStatuses from 'enums/roundReportStorageItemAdminStatuses';

import Button from '@material-ui/core/Button';
import { TextField, Checkboxes } from 'mui-rff';
import Form from 'form/Form';
import AdminFormWrapper from '../../presentational/AdminFormWrapper';
import AdminFormButtons from '../../presentational/AdminFormButtons';
import AdminFormFields from '../../presentational/AdminFormFields';

const SearchRoundReportStorageItemsForm = ({ searchParameters, onSubmit, isSubmitting = false }) => {
    return (
        <AdminFormWrapper isSubmitting={isSubmitting}>
            <Form
                initialValues={searchParameters}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <AdminFormFields>
                            <Checkboxes
                                label="Statuses"
                                name="adminStatuses"
                                data={Object.values(roundReportStorageItemAdminStatuses).map(o => ({
                                    label: o.key,
                                    value: o.key
                                }))}
                                formGroupProps={{ row: true }}
                            />
                            <TextField
                                name="q"
                                label="Storage site or owner actor"
                                variant="outlined"
                            />
                        </AdminFormFields>
                        <AdminFormButtons>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Search
                            </Button>
                        </AdminFormButtons>
                    </form>
                )}
            </Form>
        </AdminFormWrapper>
    );
};

SearchRoundReportStorageItemsForm.propTypes = {
    searchParameters: PropTypes.object,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};

export default SearchRoundReportStorageItemsForm;
